import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { LotClubbingService } from './lot-clubbing.service';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { LotClubbingDto } from './dto/lot-clubbing.dto';

@ApiTags('lot-clubbing')
@Controller('lot-clubbing')
export class LotClubbingController {
    constructor(
        private lotClubbingService: LotClubbingService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,
    ) { }
    @Post('/createLotClubbing')
    async createLotClubbing(@Body() req:LotClubbingDto):Promise<CommonResponse>{
        try {
            return await this.lotClubbingService.createLotClubbing(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        } 
    }
}